import { createAction, createActionGroup, props } from '@ngrx/store';
import { ClientDevice, User, UserNotification, UserSessionData } from '@prism/prism-shared';
// ==================================================================

// ==================================================================
export const ClearCurrentUser = createAction(
  '[Logout] Clear Current User',
);
// ==================================================================
export const LoadCurrentUser = createAction(
  '[Login] Load Current User',
  props<{ userId: string; }>()
);
export const LoadCurrentUserSuccess = createAction(
  '[Login] Load Current User Success',
  props<{ user: User; }>()
);
export const SetCurrentUser = createAction(
  '[Login] Set Current User',
  props<{ user: User; }>()
);
export const LoadCurrentUserError = createAction(
  '[Login] Load Current User Error',
  props<{ error: any; }>()
);
// ==================================================================
export const LoadUsers = createAction(
  '[Login] Load Users',
);
export const LoadUsersSuccess = createAction(
  '[Login] Load Users Success',
  props<{ users: User[]; }>()
);
export const LoadUsersError = createAction(
  '[Login] Load Users Error',
  props<{ error: any; }>()
);
// ==================================================================
export const LoadUserById = createAction(
  '[Login] Load User By Id',
  props<{ userId: string; }>()
);
export const LoadUserByIdSuccess = createAction(
  '[Login] Load User By Id Success',
  props<{ user: User; }>()
);
export const LoadUserByIdError = createAction(
  '[Login] Load User By Id Error',
  props<{ error: any; }>()
);
// ==================================================================
export const UpdateCurrentUser = createAction(
  '[Login] Update Current User',
  props<{ user: User; }>()
);
// ==================================================================
export const UpdateUser = createAction(
  '[Login] Update User',
  props<{ user: User }>()
)
// ==================================================================
export const SetCurrentClientDevice = createAction(
  '[Login] Set Current Client Device',
  props<{ clientDevice: ClientDevice | null }>()
);
// ==================================================================
export const SetUserSessionData = createAction(
  '[Session Data] Set User Session Data',
  props<{ userSessionData: UserSessionData }>()
)
// ==================================================================
export const SetUserNotifications = createAction(
  '[User Notifications] Set User Notifications',
  props<{ userNotifications: UserNotification[] }>()
)
